// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const NOTICE_TYPE = Object.freeze({
  WELCOME: `welcome`,
  REJECTED: `rejected`,
  THERAPY: `therapy`,
})

export default NOTICE_TYPE
